<template>
  <label
    data-testid="sf-toggle-click-target"
    class="tw-relative tw-inline-flex tw-items-center tw-m-0"
    :class="containerClasses"
  >
    <input
      type="checkbox"
      class="tw-sr-only tw-peer"
      v-bind="attrs"
      :checked="value"
      :disabled="disabled"
    />
    <div
      v-if="icons"
      class="
        tw-rounded-2xl
        tw-w-10
        tw-h-5
        tw-font-bold
        tw-bg-sf-snow-darker
        tw-text-[8px]
        tw-transition-all
        after:tw-flex
        after:tw-items-center
        after:tw-justify-center
        after:tw-font-icon
        after:tw-text-sf-gray-light
        after:tw-text-center
        after:tw-align-middle
        after:tw-content-['\f00d']
        after:tw-absolute
        after:tw-top-[2px]
        after:tw-start-[2px]
        after:tw-bg-white
        after:tw-border
        after:tw-rounded-full
        after:tw-h-4
        after:tw-w-4
        after:tw-transition-all
        peer-checked:tw-bg-sf-primary
        peer-checked:after:tw-text-sf-primary
        peer-checked:after:tw-translate-x-[120%]
        peer-checked:after:tw-content-['\f00c']
      "
    ></div>
    <div
      v-else
      class="
        tw-rounded-2xl
        tw-w-10
        tw-h-5
        tw-font-bold
        tw-bg-sf-snow-darker
        tw-text-[8px]
        tw-transition-all
        after:tw-flex
        after:tw-items-center
        after:tw-justify-center
        after:tw-font-icon
        after:tw-text-sf-gray-light
        after:tw-text-center
        after:tw-align-middle
        after:tw-content-['']
        after:tw-absolute
        after:tw-top-[2px]
        after:tw-start-[2px]
        after:tw-bg-white
        after:tw-border
        after:tw-rounded-full
        after:tw-h-4
        after:tw-w-4
        after:tw-transition-all
        peer-checked:tw-bg-sf-primary
        peer-checked:after:tw-text-sf-primary
        peer-checked:after:tw-translate-x-[120%]
      "
    ></div>
  </label>
</template>
<script setup lang="ts">
import { computed, useAttrs } from 'vue'

import useModel from '@app/shared/vue/composables/use-model'

defineOptions({
  name: 'SfToggle',
  inheritAttrs: false,
})

interface Props {
  disabled?: boolean
  icons?: boolean
  modelValue?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  icons: true,
})

const emit =
  defineEmits<{
    'update:modelValue': [boolean]
  }>()

const $attrs = useAttrs()

const containerClasses = computed(() => {
  return {
    'tw-cursor-pointer': !props.disabled,
    'tw-opacity-50': props.disabled,
    'tw-pointer-events-none': props.disabled,
    'tw-cursor-not-allowed': props.disabled,
  }
})

const attrs = computed(() => {
  return {
    ...$attrs,
    onChange: (event: Event) => {
      const target = event.target as HTMLInputElement
      emit('update:modelValue', target.checked)
    },
  }
})

const value = useModel(props, emit)
</script>
